import React from "react";

export const education: {
  name: string;
  dates: string | JSX.Element;
  subtitle?: string | JSX.Element;
}[] = [
  {
    name: "Slovak Technical University in Bratislava",
    dates: "2017 - 2019",
    subtitle: (
      <div>
        Master's degree<div>(Intelligent software systems)</div>
      </div>
    )
  },
  {
    name: "Slovak Technical University in Bratislava",
    dates: "2014 - 2017",
    subtitle: (
      <div>
        Bachelor's degree <div className="text-sm italic">(Informatics)</div>
      </div>
    )
  },
  {
    name: "Gymnasium Šrobárová 1, Košice",
    dates: "2010 - 2014",
    subtitle: "General education"
  },
  {
    name: "Elementary school, Michalany",
    dates: "2001 - 2010"
  }
];
